<template>
    <b-container class="mt-5">
        <h3 class="mb-4">{{ owner.nickname }}</h3>
        <b-table
            striped
            hover
            :items="forms.hits"
            :fields="['name']"
            thead-class="d-none"
            >
            <template #cell()="data">
                <b-row>
                    <b-col md="6" class="align-self-center py-2">
                        <b-link :href="`/f/${owner.uuid}/${data.item.uuid}`">
                            {{ data.item.name }}
                        </b-link>
                    </b-col>
    
                    <b-col md="6" class="align-self-center">
                        <FormDate :model="data.item" />
                    </b-col>
                </b-row>
            </template>
        </b-table>

        <div
            v-if="!forms.hits || forms.hits.length === 0"
            >
            <b-card class="text-center p-5 mb-5">
<!--
                公開されているフォームは現在ありません。
-->
                現在は申込受付期間外です。
                次回の申込受付期間については、決まり次第こちらでご案内します。
            </b-card>
        </div>

        <div>
            <b-card>
                <b-button v-b-toggle.collapse-policy variant="light" class="w-100 my-3">特定商取引法、プライバシーポリシー</b-button>
                <b-collapse id="collapse-policy">
                    <div class="mb-5" v-html="owner.policy">
                    </div>
               </b-collapse>
            </b-card>
        </div>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import FormBadges from '@/components/FormBadges.vue'
import FormDate from '@/components/FormDate.vue'
import FormInfo from '@/components/FormInfo.vue'

export default {
    components: {
        FormBadges,
        FormDate,
        FormInfo,
    },
    props: {
        user_uuid: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'trans',
        ]),
    },
    data() {
        return {
            owner: {},
            forms: {},
        }
    },
    watch: {
        $route: {
            async handler () {
                this.fetch()
            },
            immediate: true
        }
    },
    mounted() {
        window.setTimeout(() => {
            this.scrollTop()
        }, 500)
    },
    methods: {
        async fetch () {
            this.fetchOwner()
            this.fetchForms()
        },
        async fetchOwner () {
            const response = await this.$store.dispatch('user/show', this.user_uuid)
            if (this.isResponseError(response)) {
                return false
            }
            this.owner = response.data
        },
        async fetchForms () {
            const response = await this.$store.dispatch('form/list', this.user_uuid)
            if (this.isResponseError(response)) {
                return false
            }
            this.forms = response.data
        },
        scrollTop: function(){
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        }
    },
}
</script>

